import text from "./config/texts/en.json";

export default {
  t: (key, fallbackOrReplacements = key, fallback = key) => {
    const splits = key.split(".");
    let replacements = {};

    if (typeof fallbackOrReplacements === "object") {
      replacements = fallbackOrReplacements;
    } else {
      fallback = fallbackOrReplacements;
    }

    try {
      let rText = splits.reduce((parts, k) => parts[k], text) || fallback;

      if (typeof rText === "object") {
        if (rText.one && rText.more) {
          const count = parseInt(replacements.count, 10);
          if (rText.zero && count === 0) {
            rText = rText.zero;
          } else {
            rText = count === 1 ? rText.one : rText.more;
          }
        }
      }

      return Object.keys(replacements).reduce(
        (memo, key) => memo.replaceAll(`%{${key}}`, replacements[key]),
        rText
      );
    } catch (err) {
      console.error("Translation key not found: ", key);
      return fallback;
    }
  },
};
